import {useSelector} from "react-redux";

import {attachmentsListSelector} from "webform/store/selectors";

import {Attachment} from "./Attachment";

import * as Styled from "./attachment.styled";

export const AttachmentList = () => {
    const attachments = useSelector(attachmentsListSelector);

    return (
        <Styled.AttachmentList>
            {attachments.map((attachment) => (
                <Attachment
                    attachmentId={attachment.id}
                    key={attachment.id ?? `${attachment.file.name}-${attachment.file.lastModified}`}
                    loading={!attachment.isUploaded && !attachment.error}
                    error={attachment.error}
                    file={attachment.file}
                />
            ))}
        </Styled.AttachmentList>
    );
};
